import { useAuthContext } from '@inbox-demo-nx/contexts';
import { ColStack, RowStack, Spacer } from '@inbox-demo-nx/ui';
import Button from '@inbox-demo-nx/ui-button';
import { Avatar } from '@inbox-demo-nx/ui-chat-common';
import { H2, Text } from 'dripsy';
import { ViewProps } from 'react-native';

export const CurrentUserProfile = () => {
  const { currentUser } = useAuthContext();

  return (
    <RowStack style={{ justifyContent: 'center' }}>
      <Avatar size={60} user={currentUser || undefined} />
      <Spacer size={16} />
      <ColStack style={{ flex: 1 }}>
        <Text sx={{ fontWeight: 'bold', fontSize: 'large' }}>
          {currentUser?.nickname}
        </Text>
        <Text sx={{ fontSize: 'small', color: 'secondaryText' }}>
          {currentUser?.userId}
        </Text>
      </ColStack>
    </RowStack>
  );
};

export default function AppSettings(props: ViewProps) {
  const { initializeCurrentUser } = useAuthContext();

  return (
    <ColStack {...props} style={{ alignItems: 'stretch' }}>
      <H2 sx={{ fontWeight: '800' }}>Profile</H2>
      <CurrentUserProfile />
      <Spacer size={16} />
      <Button
        title="Reset"
        variant="secondary"
        onPress={initializeCurrentUser}
      />
      <Spacer size={32} />
    </ColStack>
  );
}
